// Backend authorization is store-bound, so the all-stores alerts view on the
// cookie path is assembled here from one /ads-health/{store} payload per store.

const SEVERITIES = ["critical", "warning", "info"];

export const emptyAlertsPayload = () => ({
  generated_at: null,
  summary: { critical: 0, warning: 0, info: 0, dollars_at_risk: 0 },
  alerts: [],
});

const riskOf = (body) => body?.summary?.dollars_at_risk ?? 0;

// `results` is [{ store, body }]. Stores are ordered by dollars at risk, as
// the backend orders its own all-stores payload; each store's alerts keep the
// campaign grouping the backend already applied.
export function mergeStoreAlerts(results) {
  const merged = emptyAlertsPayload();
  const ordered = [...results].sort(
    (a, b) => riskOf(b.body) - riskOf(a.body) || a.store.localeCompare(b.store)
  );

  for (const { store, body } of ordered) {
    for (const severity of SEVERITIES) {
      merged.summary[severity] += body?.summary?.[severity] ?? 0;
    }
    merged.summary.dollars_at_risk += riskOf(body);
    // The oldest snapshot bounds how fresh the merged view is.
    const generatedAt = body?.generated_at;
    if (
      generatedAt &&
      (!merged.generated_at || generatedAt < merged.generated_at)
    ) {
      merged.generated_at = generatedAt;
    }
    merged.alerts.push(
      ...(body?.alerts ?? []).map((alert) => ({
        ...alert,
        store: alert.store || store,
      }))
    );
  }

  merged.summary.dollars_at_risk =
    Math.round(merged.summary.dollars_at_risk * 100) / 100;
  return merged;
}
